import { useTranslation } from "react-i18next";
import { LegalLayout } from "./legal-layout";

export function TermsPage() {
  const { t } = useTranslation("legal");
  const sections = t("terms.sections", { returnObjects: true }) as Array<{
    heading: string;
    content: string;
  }>;
  return (
    <LegalLayout
      title={t("terms.title")}
      lastUpdated={t("terms.lastUpdated")}
      sections={sections}
    />
  );
}
